import React from 'react';
import { Helmet } from 'react-helmet-async';
import SEOAuditDashboard from '@/components/seo/validation/SEOValidationDashboard';

const SEOAuditPage = () => {
  return (
    <>
      <Helmet>
        <title>SEO Audit Dashboard - City Landings Validation</title>
        <meta name="description" content="Comprehensive SEO audit and validation system for 32,717 city landing pages" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <div className="container mx-auto py-8">
          <div className="mb-8">
            <h1 className="text-4xl font-bold mb-2">SEO Audit Dashboard</h1>
            <p className="text-muted-foreground text-lg">
              FASE 1: Auditoría y Validación de Contenido SEO para las 32,717 Landings de Ciudades
            </p>
          </div>

          <SEOAuditDashboard />
        </div>
      </div>
    </>
  );
};

export default SEOAuditPage;
